<template>
    <div id="ag-grid-demo">
            <vx-card>
                <!-- Filter Merchant -->
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/6 w-full">
                      <span>Merchant</span>
                    </div>
                    <div class="vx-col sm:w-4/5 w-full">
                        <v-select multiple :closeOnSelect="false" v-model="selected" :options="merchant_list" :dir="$vs.rtl ? 'rtl' : 'ltr'" @input="change"/>
                    </div>
                </div>

                <!-- Filter date -->
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/6 w-full">
                        <span>Date</span>
                    </div>
                    <div class="vx-col sm:w-2/5 w-full">
                      <flat-pickr id="dtp-transaction-summary-datebegin" :config="configFromdatePicker" v-model="filter.date_begin" placeholder="Date begin" @on-change="onFromChange" />
                    </div>
                    <div class="vx-col sm:w-2/5 w-full">
                      <flat-pickr id="dtp-transaction-summary-dateend" :config="configTodatePicker" v-model="filter.date_end" placeholder="Date end" @on-change="onToChange" />
                    </div>
                </div>

                 <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/6 w-full">
                        <span>Transaction Status</span>
                    </div>
                    <div class="vx-col sm:w-4/5 w-full">
                        <v-select id="cbo-device" v-model="filterStatus" placeholder="Select status" :options="statusList">
                        </v-select>
                    </div>
                </div>

                <!-- Button -->
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/6 w-full">
                        <span>&nbsp;</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-button id="btn-filter" icon-pack="feather" icon="icon-search" v-on:click="fetchData()" class="mr-3 mb-2 float-left">Filter</vs-button>
                        <vs-button icon-pack="feather" icon="icon-refresh-cw" color="warning" v-on:click="resetSearch()" class="mr-3 mb-2 float-left">Reset</vs-button>
                    </div>
                </div>

            </vx-card>
            <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                    <vx-card  id="pnl-top-payment-channel-pie-card" title="Device Transaction Summary" :collapse-action="true">
                      <e-charts @click="GetTrxn($event)" id="pnl-top-payment-channel-pie-chart" :options="trxnSummary" ref="pie" auto-resize />
                    </vx-card>
                </div>
        
                 <div class="vx-col md:w-1/2 w-full">
                    <vx-card  id="pnl-top-payment-channel-pie-card" title="Device Transaction Summary" :collapse-action="true">
                    <br/>
                    <h5><strong>Total Provisioned Device: {{totalData}}</strong></h5>
                   <vs-table
                            id="tbl-top-payment-channel-table"
                            stripe
                            :data="totalSummary"
                    >
                        <template slot="thead">
                            <vs-th>No</vs-th>
                            <vs-th>Status</vs-th>
                            <vs-th>Total</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                                <vs-td>{{indextr+1}}</vs-td>

                                <vs-td>{{data[indextr].status}}</vs-td>

                                <vs-td><strong>{{data[indextr].total}}</strong></vs-td>

                            
                            </vs-tr>
                        </template>
                    </vs-table>
                    </vx-card>
                </div>
            </div>

    </div>
</template>

<script>
    import {AgGridVue} from "ag-grid-vue";
    import {url} from "@/configs/apiUrl";
    import Axios from "@/global/AxiosCall";
    import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
    import vSelect from 'vue-select'
    import moment from 'moment'
    import VueSimpleSuggest from 'vue-simple-suggest';
    import 'vue-simple-suggest/dist/styles.css'
    import flatPickr from 'vue-flatpickr-component'
    import 'flatpickr/dist/flatpickr.css'
    import ECharts from 'vue-echarts/components/ECharts'
    import 'echarts/lib/component/tooltip'
    import 'echarts/lib/component/legend'
    import 'echarts/lib/chart/pie'

    export default {
        name: "DeviceTransactionSummary",
        components: {
            flatPickr,
            AgGridVue,
            VueSimpleSuggest,
            'v-select': vSelect,
            ECharts,
        },
        data(){
            return {
                merchand_code: '',
                totalSummary: [],
                totalData: 0,
                totalWarning: 0,
                totalCheck: 0,
                totalOk: 0,
                totalNoSummary: 0,
                filterStatus: '',
                statusList: [
                {id: 0, label: 'ALL'},
                  {id: 1, label: "OK"},
                  {id: 2, label: "CHECK"},
                  {id: 3, label: "WARNING"},
                  {id: 4, label: "NO_SUMMARY"},
                ],
                chosen: '',
                selected: [],
                model: null,
                mode: 'input',
                loading: false,
                log: [],
                urlx: null,
                interval: null,
                retrievingUserInfo : true,
                showMerchantFilter : true,
                userInfo : {
                    group : "root"
                },
                dateformat : "yyyy-MM-dd",
                configFromdatePicker: {
                  minDate: null,
                  maxDate: null,
                  dateFormat: 'Y-m-d',
                },
                configTodatePicker: {
                  minDate: null,
                  dateFormat: 'Y-m-d',
                },
                filterDevice: 'All Device',
                searchQuery: "",
                dataTrx: [],
                merchantSub:[],
                merchant_list: [],
                merchants:{},
                merchants_data_is_ready : false,
                filter:{
                    device : "",
                    merchant : null,
                    date_begin : "",
                    date_end : ""
                },
                trxnSummary:{
                    tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    legend: {
                    orient: 'vertical',
                    left: 'left',
                    data: []
                    },
                    series: [
                        {
                            name: 'Device Transaction Summary',
                            type: 'pie',
                            radius: '55%',
                            center: ['50%','50%'],
                            color: ['rgb(23, 201, 100)','rgb(255, 130, 0)','rgb(242, 19, 93)','#5b3cc4'],
                            data: [],
                            itemStyle: {
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                            }
                        }
                    ]
                },
            };
        },
        watch: {
            filterStatus(val) {
                if(val == null) {
                    this.filterStatus = ""
                }else {
                    this.filterStatus = val
                }
            },
        },
        computed: {
        },
        methods: {
            GetTrxn(event) {
                
                this.subset = event.data;
                    let data = {
                        date_begin: this.filter.date_begin,
                        date_end: this.filter.date_end,
                        status: this.subset.label,
                        limit:  this.totalData,
                        merchant_selected: this.selected,
                        page: 1,
                    } 
                    this.$router.push({name:'DeviceTransactionSummaries', params: {data:data}})
             
            },
            onFromChange(selectedDates, dateStr) {
                this.$set(this.configTodatePicker, 'minDate', dateStr);
            },
            onToChange(selectedDates, dateStr) {
                this.$set(this.configFromdatePicker, 'maxDate', dateStr);
            },
            isShowMerchantFilter(){
                return ((this.userInfo.group == 'issuer') ? false : true )
            },
            nullColumnRenderer(params) {
                if (params.value === null)
                    return '-'
                else
                    return params.value
            },
            change(val){
             for (let data of val){
                 if (data.code === ""){
                     this.selected = []
                     this.selected.push({full_name : "All Merchant", code : "", label : "All Merchant"})
                     break
                 }
             }
            },
            updateSearchQuery(val) {
                this.gridApi.setQuickFilter(val);
            },
            resetSearch(){
              this.selected = []
              this.filter.date_begin = moment().format("YYYY-MM-DD")
              this.filter.date_end = moment().format("YYYY-MM-DD")
              this.filterStatus = ""
              this.fetchData()
              //this.filter.merchant = ""
            },
            fetchData() {
                this.openLoading()
                let APIURL = ""
                APIURL = url.device_trxn_summary.dashboard+ "?"
                if (this.filterStatus!=='' && this.filterStatus.label !=='ALL' && this.filterStatus !== null && this.filterStatus !== undefined) {
                  APIURL += "status=" + this.filterStatus.label;
                }else {
                    APIURL += "status=ALL";
                }
                let merchant_code = ""


                let merchant_jaklingko = this.selected.filter(data => data.depth == "1" || data.full_name == "All Merchant")

                let merchant_pto = this.selected.filter(data => data.depth == "2").map(data => data.code)

                let sub_merchant_pto = this.selected.filter(data => data.depth == "3").map(data => data.code)

                if (this.selected.length >0 ){
                    if (this.selected[0].code === "" || merchant_jaklingko.length !== 0){
                        for (let data of this.merchant_list){
                            if (data.code !== "") merchant_code += data.code+","
                        }
                        this.processFetchData(APIURL,merchant_code)
                    }else if(merchant_pto !== 0){
                        let payload = {
                            merchant_code : merchant_pto,
                        }
                        Axios.Post(url.svd.merchant.comboSubMerchant , payload).then(resp => {
                            if(resp.code === 200){
                                for (let data of resp.data){
                                    if (data.code !== "") merchant_code += data.code+","
                                }
                                if (sub_merchant_pto !== 0){
                                    for (let dataSubMerchant of sub_merchant_pto){
                                        merchant_code += dataSubMerchant+","
                                    }
                                }
                                this.processFetchData(APIURL,merchant_code)
                            }else{
                                this.$vs.loading.close()
                                this.dataTrx = []
                            }
                        }) .catch(e => {
                            console.log(e);
                            this.$vs.loading.close()
                            this.dataTrx = []
                        });
                    }else{
                        for (let data of this.selected){
                            if (data.code !== "") merchant_code += data.code+","
                        }
                        this.processFetchData(APIURL,merchant_code)
                    }
                }else{
                    for (let data of this.merchant_list){
                        if (data.code !== "") merchant_code += data.code+","
                    }
                    this.processFetchData(APIURL,merchant_code)
                }

            },
            processFetchData(APIURL,merchant_code){
                merchant_code = merchant_code.replace(/,\s*$/, "")
                this.merchant_code = merchant_code
                APIURL += "&merchantcode="+merchant_code
                
                APIURL += (this.filter.date_begin !== "") ? "&date_begin="+this.filter.date_begin : ""
                APIURL += (this.filter.date_end !== "") ? "&date_end="+this.filter.date_end : ""

                Axios.Get(APIURL)
                    .then(resp => {							
                        this.$vs.loading.close()			
                        this.totalData = parseInt(resp.data.total)
                        this.totalSummary = []
                        this.totalSummary.push({status: "OK", total: resp.data.total_ok})
                        this.totalSummary.push({status: "CHECK", total: resp.data.total_check})
                        this.totalSummary.push({status: "WARNING", total: resp.data.total_warning})
                        this.totalSummary.push({status: "NO SEND SUMMARY", total: resp.data.total_no_summary})
                        this.trxnSummary.series[0].data = []
                        switch(this.filterStatus.label) {
                            case "": 
                                this.trxnSummary.series[0].data.push({
                                    name: `OK: ${resp.data.total_ok}` ,
                                    label: {id: 1, label: "OK"},
                                    value: resp.data.total_ok
                                })
                                this.trxnSummary.series[0].data.push({
                                    name: `CHECK: ${resp.data.total_check}`,
                                    label: {id: 2, label: "CHECK"},
                                    value: resp.data.total_check
                                })
                                this.trxnSummary.series[0].data.push({
                                    name: `WARNING: ${resp.data.total_warning}`,
                                    label: {id: 3, label: "WARNING"},
                                    value: resp.data.total_warning
                                })
                                this.trxnSummary.series[0].data.push({
                                    name: `NO SUMMARY ${resp.data.total_no_summary}`,
                                    label: {id: 4, label: "NO_SUMMARY"},
                                    value: resp.data.total_no_summary
                                })
                            break;
                            case "OK":
                                this.trxnSummary.series[0].data.push({
                                    name: `OK: ${resp.data.total_ok}` ,
                                    label: {id: 1, label: "OK"},
                                    value: resp.data.total_ok
                                })
                            break;
                            case "CHECK":
                                this.trxnSummary.series[0].data.push({
                                    name: `CHECK: ${resp.data.total_check}`,
                                    label:{id: 2, label: "CHECK"},
                                    value: resp.data.total_check
                                })
                            break;
                            case "WARNING":
                                this.trxnSummary.series[0].data.push({
                                    name: `WARNING: ${resp.data.total_warning}`,
                                    label:  {id: 3, label: "WARNING"},
                                    value: resp.data.total_warning
                                })
                            break;
                            case "NO_SUMMARY":
                                this.trxnSummary.series[0].data.push({
                                    name: `NO SUMMARY ${resp.data.total_no_summary}`,
                                    label: {id: 4, label: "NO_SUMMARY"},
                                    value: resp.data.total_no_summary
                                })
                            break;
                            default:
                                this.trxnSummary.series[0].data.push({
                                    name: `OK: ${resp.data.total_ok}` ,
                                    label: {id: 1, label: "OK"},
                                    value: resp.data.total_ok
                                })
                                this.trxnSummary.series[0].data.push({
                                    name: `CHECK: ${resp.data.total_check}`,
                                    label: {id: 2, label: "CHECK"},
                                    value: resp.data.total_check
                                })
                                this.trxnSummary.series[0].data.push({
                                    name: `WARNING: ${resp.data.total_warning}`,
                                    label:  {id: 3, label: "WARNING"},
                                    value: resp.data.total_warning
                                })
                                this.trxnSummary.series[0].data.push({
                                    name: `NO SUMMARY ${resp.data.total_no_summary}`,
                                    label: {id: 4, label: "NO_SUMMARY"},
                                    value: resp.data.total_no_summary
                                })
                        }

                    })
                    .catch(e => {
                        console.log(e);
                        this.$vs.loading.close()
                        this.dataTrx = []
                    });
            },
            openLoading() {
                this.$vs.loading({
                    type: "default"
                });
            },
        },
        mounted() {
            this.urlx = url
            try{
                this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
            }catch(e){
                console.log(e)
            }

            this.filter.date_begin = moment().format("YYYY-MM-DD")
            this.filter.date_end = moment().format("YYYY-MM-DD")


            Axios.GetUserFromToken(url.svd.auth.me, {authToken:(typeof this.userInfo.access_token.token == 'undefined') ? "" : this.userInfo.access_token.token}).then(response =>{
                if(response.data.code == 200){
                    if(response.data.data.role_details.length > 0){
                        this.userInfo.group = response.data.data.role_details[0].group
                    }
                }
                this.showMerchantFilter = this.isShowMerchantFilter()
                this.filter.merchant = this.showMerchantFilter ? "" : this.userInfo.merchant.code

                Axios.Get(url.svd.merchant.combo).then(resp => {
                    //this.merchant_list = resp.data

                    for(let data of resp.data) {
                      let depth = '- '
                      data.label = depth.repeat(data.depth)+data.full_name
                        if (this.userInfo.merchant.id !== undefined){
                            if (this.userInfo.merchant.id == data.id || parseInt(data.depth) > parseInt(this.userInfo.merchant.depth)){
                                if (data.depth < 4) {
                                    this.merchant_list.push(data)
                                }
                            }
                        }else{
                            if (data.depth < 4) {
                                this.merchant_list.push(data)
                            }
                        }
                    }

                    this.merchant_list.unshift({full_name : "All Merchant", code : "", label : "All Merchant"})
                    for(let idx = 0;idx < resp.data.length;idx++){
                        this.merchants[resp.data[idx].code] = resp.data[idx].full_name
                    }
           
                    this.fetchData()
                })
            })

        }
    }
</script>

<style>
    .flatpickr-input {
        padding: .7rem;
        font-size: 1rem;
        border-radius: 5px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        color: #626262;
        width: 100%;
    }

  .vue-simple-suggest.designed .suggestions {
      position: absolute;
      left: 0;
      right: 0;
      top: 100%;
      top: calc(100% + 5px);
      border-radius: 3px;
      border: 1px solid #aaa;
      background-color: #fff;
      opacity: 1;
      z-index: 1000;
      overflow: scroll;
      height: 300px;
  }
</style>